import { createRouter, createWebHistory } from 'vue-router';
import { isMobile } from '~/@func/isMobile';

let routes: any = [];

routes = [
  { name: 'login', path: '/', component: () => import('./login/index.vue') },
  { name: 'logout', path: '/logout', component: () => import('./logout/index.vue') },

  { name: 'privacy', path: '/privacy', component: () => import('./login/privacy/index.vue') },
  { name: 'rule', path: '/rule', component: () => import('./login/rule/index.vue') },

  {
    name: 'regist',
    path: '/regist/:id/:registKey',
    component: () => import('./login/regist/index.vue'),
  },
  {
    name: 'invite',
    path: '/invite/:id/:inviteKey',
    component: () => import('./login/invite/index.vue'),
  },
  {
    name: 'passwordSend',
    path: '/password/send',
    component: () => import('./login/password/send/index.vue'),
  },
  {
    name: 'passwordReset',
    path: '/password/reset',
    component: () => import('./login/password/reset/index.vue'),
  },

  {
    path: '/home',
    component: () => import('./home/index.vue'),
    children: [
      {
        name: 'home',
        path: '',
        component: () => import('./home/menu/index.vue'),
      },
      {
        name: 'systemInformationDetail',
        path: 'information',
        component: () => import('./home/systemInformationDetail/index.vue'),
      },
    ],
  },
  {
    name: 'commonLogout',
    path: '/common/logout',
    component: () => import('./common/logout.vue'),
  },
  {
    path: '/inquiry',
    component: () => import('./inquiry/index.vue'),
    children: [
      {
        name: 'inquiryList',
        path: '',
        component: () => import('./inquiry/list/index.vue'),
      },
      {
        name: 'inquiryDetail',
        path: 'detail',
        component: () => import('./inquiry/detail/index.vue'),
      },
      {
        name: 'inquiryContact',
        path: 'contact',
        component: () => import('./inquiry/contact/index.vue'),
      },
    ],
  },
  {
    path: '/order',
    component: () => import('./order/index.vue'),
    children: [
      {
        name: 'orderList',
        path: '',
        component: () => import('./order/list/index.vue'),
      },
      {
        name: 'orderDetail',
        path: 'detail',
        component: () => import('./order/detail/index.vue'),
      },
    ],
  },
  {
    path: '/warehouse_schedule',
    component: () => import('./warehouseSchedule/index.vue'),
    children: [
      {
        name: 'warehouseScheduleList',
        path: '',
        component: () => import('./warehouseSchedule/list/index.vue'),
      },
    ],
  },
  {
    path: '/warehouse',
    component: () => import('./warehouse/index.vue'),
    children: [
      {
        name: 'warehouseList',
        path: '',
        component: () => import('./warehouse/list/index.vue'),
      },
      {
        name: 'warehouseDetail',
        path: 'detail',
        component: () => import('./warehouse/detail/index.vue'),
      },
    ],
  },
  {
    name: 'contact',
    path: '/contact',
    component: () => import('./login/contact/index.vue'),
  },
  {
    path: '/config',
    component: () => import('./config/index.vue'),
    children: [
      {
        name: 'configMenu',
        path: 'menu',
        component: () => import('./config/menu/index.vue'),
      },
      {
        name: 'configSystemUserList',
        path: 'system_user/list',
        component: () => import('./config/systemUser/index.vue'),
      },
      {
        name: 'configSystemUserDetail',
        path: 'system_user/detail',
        component: () => import('./config/systemUser/detail/index.vue'),
      },

      {
        name: 'configProfile',
        path: 'profile',
        component: () => import('./config/profile/index.vue'),
      },
      {
        name: 'configPassword',
        path: 'password',
        component: () => import('./config/password/index.vue'),
      },
    ],
  },
  //NotFoundページは一番最後に書く必要がある
  { name: 'notFound', path: '/:catchAll(.*)', component: () => import('./common/notFound.vue') },
];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

export default router;
